import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {PaletteColorsEnum} from '../../../../libs/shared/core/src/models/api/paletteModel';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

export interface VisitorUnsubscribedAllBannerProps {
  isVisitorSubscribedAll: boolean;
  resubscribeAllVisitorNotifications: () => void;
}

/*
 * Style.
 */

const StyledBannerDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  background: ${(p) => p.theme.palette.orange.shade20};
  text-align: center;
  vertical-align: text-bottom;
  padding: 8px;
`;

const StyledBannerContentSpan = styled.span`
  color: ${(p) => p.theme.greys.shade90};
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.medium};
  line-height: ${fontSizes.large};
  padding: 4.5px 10px;
`;

const StyledResubscribeButtonContentSpan = styled.span`
  text-transform: uppercase;
`;

/*
 * Component.
 */

export const VisitorUnsubscribedAllBanner: FC<VisitorUnsubscribedAllBannerProps> = (props) => {
  const theme = useUserTheme();
  const {isVisitorSubscribedAll, resubscribeAllVisitorNotifications} = props;

  if (isVisitorSubscribedAll) {
    return null;
  }
  return (
    <StyledBannerDiv>
      <Icon name="muteFilled" color={theme.palette.orange.shade50} />
      <StyledBannerContentSpan>
        <Trans id="visitor-unsubscribed-all-content">
          You&apos;re unsubscribed from all current and future conversations.
        </Trans>
      </StyledBannerContentSpan>
      <Button
        size={VisualSizesEnum.SMALL}
        variant={ButtonVariantsEnum.LINK}
        color={PaletteColorsEnum.ORANGE}
        onClick={resubscribeAllVisitorNotifications}
      >
        <StyledResubscribeButtonContentSpan>
          <Trans id="visitor-resubscribe-button">resubscribe</Trans>
        </StyledResubscribeButtonContentSpan>
      </Button>
    </StyledBannerDiv>
  );
};
